const DEFAULT_KAJABI_AUTH_URL = 'https://app.kajabi.com/oauth/authorize';
const DEFAULT_KAJABI_SCOPE = 'email';

const normalizeInstitutionCode = (institutionCode = '') =>
	institutionCode.toString().trim().toUpperCase();

const getEnvBySuffix = (suffix) =>
	(process.env[`REACT_APP_${suffix}`] || '').toString().trim();

const removeNumericSuffix = (code = '') => code.replace(/_[0-9]+$/, '');

export const getKajabiCredentials = (institutionCode) => {
	const inputCode = normalizeInstitutionCode(institutionCode);
	const envInstitutionCode = normalizeInstitutionCode(
		process.env.REACT_APP_INSTITUTION_CODE || '',
	);

	const candidateCodes = Array.from(
		new Set([
			inputCode,
			removeNumericSuffix(inputCode),
			envInstitutionCode,
			removeNumericSuffix(envInstitutionCode),
		].filter(Boolean)),
	);

	const getFirstByCandidates = (prefix) => {
		for (const code of candidateCodes) {
			const value = getEnvBySuffix(`${prefix}_${code}_KAJABI`);
			if (value) return value;
		}
		return '';
	};

	const clientId = getFirstByCandidates('CLIENTID');
	const redirectUri =
		getFirstByCandidates('REDIRECTURI') ||
		`${window.location.origin}/kajabi-callback`;
	const scope = getFirstByCandidates('SCOPE') || DEFAULT_KAJABI_SCOPE;
	const state = getFirstByCandidates('STATE') || 'kajabi';
	const authUrl =
		getFirstByCandidates('AUTHURL') ||
		getEnvBySuffix('KAJABI_AUTH_URL') ||
		DEFAULT_KAJABI_AUTH_URL;

	return {
		client_id: clientId || null,
		redirect_uri: redirectUri,
		scope,
		state,
		authorize_url: authUrl,
	};
};
